/**
 * Centralized external (off-app) URLs. Legal pages live on the LP
 * (lp.orbitlens.io) — see lp/privacy.html and lp/terms.html — so the consent
 * links in Login / ControlRoom and any future surface all point at one source.
 */
export const EXTERNAL_LINKS = {
  privacyPolicy: "https://lp.orbitlens.io/privacy.html",
  termsOfService: "https://lp.orbitlens.io/terms.html",
  // EIS is the open-source observation engine OrbitLens is built on. Surfaced as
  // an optional, no-pressure sponsor link on the Plan page (NOT a paid CTA).
  eisRepo: "https://github.com/machuz/eis",
  eisSponsor: "https://github.com/sponsors/machuz",
} as const;
